import React, { useEffect, useRef, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { useParams } from 'react-router-dom';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import { addDays, format } from 'date-fns';
import TreatTemletList from './TreatTemletList';
import { useSelector } from 'react-redux';

function GoalPlanPupup({
  treatmentId,
  handleReload,
  handleClose,
  goalId,
  goalNo,
  goalstatus,
}) {
  const { user } = useSelector((state) => state.auth);
  const { patientId } = useParams();
  const [allData, setAllData] = useState(new Date());

  const [treatGenDate, setTreatGenDate] = useState(new Date());
  const [treatGenDatePickerIsOpen, setTreatGenDatePickerIsOpen] =
    useState(false);
  const [reviewIn, setReviewIn] = useState('');
  const [reviewInDate, setReviewInDate] = useState('');

  const [selectedBlock, setSelectedBlock] = useState('1_0_0');
  const [defaultAccord, setDefaultAccord] = useState('goal');

  const [goalArea, setGoalArea] = useState('');

  const [goalTempListArr, setGoalTempListArr] = useState(null);
  const [objectTempListArr, setObjectTempListArr] = useState(null);
  const [intervenTempListArr, setIntervenTempListArr] = useState(null);

  const [objStatusArr, setObjStatusArr] = useState(null);
  const [goalArr, setGoalArr] = useState([
    {
      completDate: null,
      status: '',
      objText: '',
      interven: [''],
      reviewArea: [''],
    },
  ]);

  const reviewRefs = useRef([]);

  useEffect(() => {
    reviewRefs.current[reviewRefs.current.length - 1] &&
      reviewRefs.current[reviewRefs.current.length - 1].focus();
  }, []);

  function openDatePicker() {
    setTreatGenDatePickerIsOpen(!treatGenDatePickerIsOpen);
  }

  function handleDateSelect(dateEvent) {
    setTreatGenDatePickerIsOpen(!treatGenDatePickerIsOpen);
  }

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/treatmentPlan/addTreatmentGoal',
          {
            patientId: patientId,
            goalNo: goalNo,
            goalId: goalId,
            treatmentId: treatmentId,
            staffUserId: user?.id,
            userType: '1',
          },
        );
        if (response.status === 200) {
          setAllData(response?.data);
          setGoalTempListArr(response?.data?.goalTempletArrs);
          setObjectTempListArr(response?.data?.objTempletArrs);
          setIntervenTempListArr(response?.data?.intTempletArrs);
          setObjStatusArr(response?.data?.objStatus);
          setReviewIn(response?.data?.selReviewIn);
          setReviewInDate(response?.data?.selReviewDate);

          setGoalArea(response?.data?.goalDetail ?? '');

          let tempArr = [];
          if (response?.data?.objArr && response?.data?.objArr.length > 0) {
            response?.data?.objArr?.forEach((ele, i) => {
              const revArr =
                ele?.reviewDetailArr.length > 0
                  ? ele?.reviewDetailArr.map((int, j) => {
                      return int?.review_title;
                    })
                  : [''];
              tempArr.push({
                completDate:
                  ele?.completionDate && ele?.completionDate !== '0000-00-00'
                    ? new Date(ele?.completionDate)
                    : '',
                status: ele?.objStatus,
                objText: ele?.objDetail,
                interven: [
                  ...ele?.interDetailArr.map((int, j) => {
                    return int?.intervention_title;
                  }),
                ],
                reviewArea: [...revArr],
              });
            });
            setGoalArr(tempArr);
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, goalNo, goalId, user, treatmentId]);

  const handleReviewList = (e) => {
    setReviewIn(e.target.value);
    let days = e.target.options[e.target.selectedIndex].text
      ? e.target.options[e.target.selectedIndex].text.split(' ')[0]
      : '';
    if (days) {
      setReviewInDate(addDaysAndFormat(days));
    } else {
      setReviewInDate('');
    }
  };

  const addDaysAndFormat = (days) => {
    const currentDate = new Date();
    const finalDate = addDays(currentDate, days);
    const formattedDate = format(finalDate, DEFAULT_DATE_FORMATE);
    return formattedDate;
  };

  const apiCallFun = async (id, name) => {
    try {
      if (id) {
        const response = await post(
          'api/patient/treatmentPlan/mhtpTempletListSelect',
          {
            id: id,
          },
        );
        if (response.status === 200) {
          const changeGoalArr = [...goalArr];
          const seltBlockArr = selectedBlock.split('_');

          if (seltBlockArr) {
            let i = seltBlockArr[1] - 1;
            let j = seltBlockArr[2] - 1;

            if (name === 'goal') {
              setGoalArea(
                goalArea ? goalArea + '\n' + response?.data : response?.data,
              );
            } else if (name === 'object') {
              changeGoalArr[i].objText = changeGoalArr[i].objText
                ? changeGoalArr[i].objText + '\n' + response?.data
                : response?.data;
              setGoalArr(changeGoalArr);
            } else if (name === 'intervention') {
              changeGoalArr[i].interven[j] = changeGoalArr[i].interven[j]
                ? changeGoalArr[i].interven[j] + '\n' + response?.data
                : response?.data;
              setGoalArr(changeGoalArr);
            }
          } else {
            setUiMessage(
              'err',
              'Please select a textarea where you want to write',
            );
          }
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleSideBarAccord = (name) => {
    setDefaultAccord(name);
    if (name === 'goal') {
      setSelectedBlock('1_0_0');
    } else if (name === 'obj') {
      setSelectedBlock('1_1_0');
    } else if (name === 'int') {
      setSelectedBlock('1_1_1');
    }
  };

  const handleAddObj = () => {
    setGoalArr([
      ...goalArr,
      {
        completDate: null,
        status: '',
        objText: '',
        interven: [''],
        reviewArea: [''],
      },
    ]);
  };

  const handleChangeCompDate = (date, i) => {
    const onChangeVal = [...goalArr];
    onChangeVal[i].completDate = date;
    setGoalArr(onChangeVal);
  };

  const handleChangeStatus = (e, i) => {
    const onChangeVal = [...goalArr];
    onChangeVal[i].status = e.target.value;
    setGoalArr(onChangeVal);
  };

  const handleObjChange = (e, i) => {
    const onChangeVal = [...goalArr];
    onChangeVal[i].objText = e.target.value;
    setGoalArr(onChangeVal);
  };

  const handleRemoveObj = (num) => {
    const deltedArr = [...goalArr];
    deltedArr.splice(num, 1);
    setGoalArr(deltedArr);
  };

  const handleAddInterVen = (i) => {
    const editArr = [...goalArr];
    editArr[i]['interven'].push('');
    setGoalArr(editArr);
  };

  const handleInterChange = (e, i, j) => {
    const onChangeVal = [...goalArr];
    onChangeVal[i].interven[j] = e.target.value;
    setGoalArr(onChangeVal);
  };

  const handleRemoveInterVen = (i, j) => {
    const editArr = [...goalArr];
    editArr[i]?.interven.splice(j, 1);
    setGoalArr(editArr);
  };

  const handleSelectedBox = (str, name) => {
    //alert(str);
    setSelectedBlock(str);
    setDefaultAccord(name);
  };

  const handleGoalPopup = async () => {
    try {
      let obj = {
        goal_title: goalArea,
        totalObj: goalArr.length,
        treatmentId: treatmentId,
        goalId: goalId || '', //at the time add goal goal id will be blank
        therapyReview: reviewIn,
        therapyReviewDate: reviewInDate,
        therapyDate: format(treatGenDate, DEFAULT_DATE_FORMATE),
        staffUserId: user?.id,
      };

      for (let i = 0; i < goalArr.length; i++) {
        obj[`objStatus${i + 1}`] = goalArr[i].status;
        obj[`completionObj${i + 1}`] = goalArr[i].completDate
          ? format(goalArr[i].completDate, DEFAULT_DATE_FORMATE)
          : '';
        obj[`objText${i + 1}`] = goalArr[i].objText;
        obj[`totalInt${i + 1}`] = goalArr[i].interven.length;
        for (let j = 0; j < goalArr[i].interven.length; j++) {
          obj[`obj_${i + 1}_intText${j + 1}`] = goalArr[i].interven[j];
        }
        obj[`totalReview${i + 1}`] = goalArr[i].reviewArea.length;
        for (let k = 0; k < goalArr[i].reviewArea.length; k++) {
          obj[`obj_${i + 1}_reviewText${k + 1}`] = goalArr[i].reviewArea[k];
        }
      }

      const response = await post(
        'api/patient/treatmentPlan/saveGoalForm',
        obj,
      );
      if (response.status === 200) {
        handleClose(false);
        handleReload('goal');
        handleReload('treat');
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleReviewArea = (e, i, k) => {
    const onChangeVal = [...goalArr];
    onChangeVal[i].reviewArea[k] = e.target.value;
    setGoalArr(onChangeVal);
  };

  const handleAddReviewSec = (i) => {
    const editArr = [...goalArr];
    editArr[i]['reviewArea'].push('');
    setGoalArr(editArr);
  };

  const handleRemoveReviewSec = (i, k) => {
    const editArr = [...goalArr];
    editArr[i]?.reviewArea.splice(k, 1);
    setGoalArr(editArr);
  };

  return (
    <div className="modalBackground">
      <div className="main-contnr tp-goalpoup-main-con center-popup qhide">
        <div className="main-contnr-hdr flex-sec">
          <div className="hdr-pt-info">
            <span className="black-txt clear-right10">Treatment Plan:</span>
            {allData?.patientName}
            <span className="red"> | </span>
            ID: {allData?.chartNo}
            <span className="red"> | </span>
            {allData?.age} yrs-[{allData?.gender?.substr(0, 1)}]
            <span className="red"> | </span>
            DOB:{allData?.dob}
          </div>
          <div className="Close" onClick={handleClose}>
            X
          </div>
        </div>
        <div
          className="main-contnr-bdy tp-comn-poup-bdy"
          style={{ overflow: 'unset' }}
        >
          <div className="pop-up-prnt-blk flex-sec tp-frt-blk">
            <div className="width50">
              <div className="appt-hx-fa-rw">
                <span className="txt-label clear-top5">Date:</span>
                <span
                  className="value"
                  style={{ display: 'flex', flexBasis: '62%' }}
                >
                  <ReactDatePicker
                    selected={treatGenDate}
                    onChange={(date) => setTreatGenDate(date)}
                    onClickOutside={openDatePicker}
                    open={treatGenDatePickerIsOpen}
                    onSelect={handleDateSelect}
                    className="app-date-picker"
                    dateFormat={DEFAULT_DATE_FORMATE}
                  />
                  <img
                    width="13%"
                    src="./images/calendar-icon.png"
                    alt=""
                    onClick={openDatePicker}
                    style={{ marginLeft: '7px' }}
                  />
                </span>
              </div>
              <div className="appt-hx-fa-rw">
                <span className="txt-label"> Review in:</span>
                <span className="txt-val">
                  <select
                    className="book-appt-dd"
                    data-placeholder="Select"
                    value={reviewIn}
                    onChange={(e) => handleReviewList(e)}
                    style={{ width: '42%' }}
                  >
                    <option value="">{''}</option>
                    {allData?.reviewList?.map((data, i) => (
                      <option key={i} value={data?.id}>
                        {data?.title}
                      </option>
                    ))}
                  </select>
                  <input
                    type="text"
                    className="apptTime clear-left10 width50"
                    placeholder="mm-dd-yyyy"
                    value={reviewInDate}
                    readOnly={true}
                  />
                </span>
              </div>
            </div>
            <div className="width50">
              <span className="bold">
                <u>Problems:</u>
              </span>
              <div className="appt-hx-fa-rw clear-top10">
                <div className="">
                  {allData?.selDxList &&
                    allData?.selDxList.map((data, i) => (
                      <div key={i} className="added-dx">
                        <span className="">{data?.label}</span>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <div
            className="width100 flex-sec"
            style={{
              padding: '0px 9px 0px 6px',
              borderBottom: '1px solid #dadada',
            }}
          >
            <div className="mat-cnslng-col1">
              <div className="mat-cnslng-col1-rw">
                <span
                  className="pop-up-sb-hdr flex-sec"
                  onClick={() => handleSideBarAccord('goal')}
                >
                  <span className="cnslng-acrdn-arw">
                    {defaultAccord === 'goal' ? (
                      <div dangerouslySetInnerHTML={{ __html: '&#9660;' }} />
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: '&#9658;' }} />
                    )}
                  </span>
                  <span className="cnslng-acrdn-txt">Goals</span>
                </span>
                <div
                  className={
                    defaultAccord === 'goal'
                      ? 'dx-bloc-tmplt-lt grid-sec'
                      : 'dx-bloc-tmplt-lt grid-sec hide'
                  }
                  style={{ marginBottom: '5px' }}
                >
                  {goalTempListArr && (
                    <TreatTemletList
                      listArr={goalTempListArr}
                      apiCallFun={apiCallFun}
                      name={'goal'}
                    />
                  )}
                </div>
              </div>
              <div className="mat-cnslng-col1-rw">
                <span
                  className="pop-up-sb-hdr flex-sec"
                  onClick={() => handleSideBarAccord('obj')}
                >
                  <span className="cnslng-acrdn-arw">
                    {defaultAccord === 'obj' ? (
                      <div dangerouslySetInnerHTML={{ __html: '&#9660;' }} />
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: '&#9658;' }} />
                    )}
                  </span>
                  <span className="cnslng-acrdn-txt">Objectives</span>
                </span>
                <div
                  className={
                    defaultAccord === 'obj'
                      ? 'dx-bloc-tmplt-lt grid-sec'
                      : 'dx-bloc-tmplt-lt grid-sec hide'
                  }
                >
                  {objectTempListArr && (
                    <TreatTemletList
                      listArr={objectTempListArr}
                      apiCallFun={apiCallFun}
                      name={'object'}
                    />
                  )}
                </div>
              </div>
              <div className="mat-cnslng-col1-rw">
                <span
                  className="pop-up-sb-hdr flex-sec"
                  onClick={() => handleSideBarAccord('int')}
                >
                  <span className="cnslng-acrdn-arw">
                    {defaultAccord === 'int' ? (
                      <div dangerouslySetInnerHTML={{ __html: '&#9660;' }} />
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: '&#9658;' }} />
                    )}
                  </span>
                  <span className="cnslng-acrdn-txt">Interventions</span>
                </span>
                <div
                  className={
                    defaultAccord === 'int'
                      ? 'dx-bloc-tmplt-lt grid-sec'
                      : 'dx-bloc-tmplt-lt grid-sec hide'
                  }
                  onClick={() => handleSideBarAccord('int')}
                >
                  {intervenTempListArr && (
                    <TreatTemletList
                      listArr={intervenTempListArr}
                      apiCallFun={apiCallFun}
                      name={'intervention'}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="mat-cnslng-col3">
              <div className="mat-cnslng-col3-rw">
                <div className="mat-cnslng-col3-chld-rw grid-sec">
                  <div className="grid-sec">
                    <span className="pop-up-sb-hdr">Goal #{goalNo}</span>
                    <textarea
                      className="cnslng-poup-txtrea"
                      placeholder="Write here..."
                      spellCheck="true"
                      value={goalArea}
                      onChange={(e) => setGoalArea(e.target.value)}
                      onClick={() => handleSelectedBox(`1_0_0`, 'goal')}
                    ></textarea>
                  </div>
                </div>
                {goalArr &&
                  goalArr.map((data, i) => (
                    <div
                      key={i}
                      className="mat-cnslng-col3-chld-rw grid-sec clear-left15"
                    >
                      <div className="grid-sec">
                        <div className="pop-up-sb-hdr flex-sec">
                          <span style={{ width: '85%' }}>
                            Objective# {i + 1}
                          </span>
                          {i === 0 ? (
                            <span
                              className="right link-color cursor"
                              onClick={handleAddObj}
                            >
                              [Add More]
                            </span>
                          ) : (
                            <span
                              className="right link-color cursor"
                              onClick={() => handleRemoveObj(i)}
                            >
                              [Remove]
                            </span>
                          )}
                        </div>
                        <div className="flex-sec width100">
                          <div className="clear-left15 clear-right10 flex-sec">
                            <span
                              className="clear-left10 clear-right10"
                              syle={{ display: 'flex' }}
                            >
                              Completion:
                            </span>
                            <span
                              className="value"
                              style={{ display: 'flex', flexBasis: '62%' }}
                            >
                              <ReactDatePicker
                                placeholder="mm-dd-yyyy"
                                selected={data?.completDate}
                                onChange={(date) =>
                                  handleChangeCompDate(date, i)
                                }
                                className="app-date-picker"
                                dateFormat={DEFAULT_DATE_FORMATE}
                              />
                            </span>
                          </div>
                          <div className="clear-left15 width50">
                            <span className="clear-left10 clear-right10">
                              Status
                            </span>
                            <select
                              className="width50"
                              style={{ height: '26px', marginBottom: '5px' }}
                              value={data?.status}
                              onChange={(e) => handleChangeStatus(e, i)}
                            >
                              <option value=""></option>
                              {objStatusArr &&
                                objStatusArr.map((data, i) => (
                                  <option key={i} value={data?.id}>
                                    {data?.val}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <textarea
                          className="cnslng-poup-txtrea"
                          style={{ marginTop: '3px' }}
                          placeholder="Write here..."
                          value={data?.objText}
                          spellCheck="true"
                          onChange={(e) => handleObjChange(e, i)}
                          onClick={() =>
                            handleSelectedBox(`1_${i + 1}_0`, 'obj')
                          }
                        ></textarea>
                      </div>
                      {data?.interven?.map((int, j) => (
                        <div
                          key={j}
                          className="mat-cnslng-col3-chld-rw grid-sec clear-left15"
                        >
                          <div className="grid-sec">
                            <div className="pop-up-sb-hdr flex-sec">
                              <span
                                className="qintervntn-hdng"
                                style={{ width: '83%' }}
                              >
                                Intervention# {j + 1}
                              </span>
                              {j === 0 ? (
                                <span
                                  className="link-color clear-left10 cursor"
                                  onClick={() => handleAddInterVen(i)}
                                >
                                  [Add More]
                                </span>
                              ) : (
                                <span
                                  className="link-color clear-left10 cursor"
                                  onClick={() => handleRemoveInterVen(i, j)}
                                >
                                  [Remove]
                                </span>
                              )}
                            </div>
                            <textarea
                              className="cnslng-poup-txtrea"
                              placeholder="Write here..."
                              value={int}
                              onChange={(e) => handleInterChange(e, i, j)}
                              spellCheck="true"
                              onClick={() =>
                                handleSelectedBox(`1_${i + 1}_${j + 1}`, 'int')
                              }
                            ></textarea>
                          </div>
                        </div>
                      ))}
                      {((goalstatus === '3' && goalId) ||
                        allData?.reviewExist === '1') && (
                        <div className="mat-cnslng-col3-chld-rw grid-sec clear-left15 clear-top10">
                          {data?.reviewArea?.map((rev, k) => (
                            <div key={k} className="grid-sec">
                              <span className="width100">
                                <span className="intervntn-hdng">
                                  Review#:{k + 1}
                                </span>
                                {k === 0 ? (
                                  <span
                                    className="link-color clear-left10 cursor"
                                    onClick={() => handleAddReviewSec(i)}
                                  >
                                    [Add More]
                                  </span>
                                ) : (
                                  <span
                                    className="link-color clear-left10 cursor"
                                    onClick={() => handleRemoveReviewSec(i, k)}
                                  >
                                    [Remove]
                                  </span>
                                )}
                              </span>
                              <textarea
                                className="cnslng-poup-txtrea"
                                placeholder="Write here..."
                                value={rev}
                                onChange={(e) => handleReviewArea(e, i, k)}
                                spellCheck="true"
                                ref={(textarea) =>
                                  (reviewRefs.current[k] = textarea)
                                }
                              ></textarea>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div className="gnrl-dtl-btn-rw">
          {goalId ? (
            <button className="actn-yes" onClick={handleGoalPopup}>
              Update
            </button>
          ) : (
            <button className="actn-yes" onClick={handleGoalPopup}>
              Save
            </button>
          )}

          <button className="actn-No" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default GoalPlanPupup;
